import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { browserName, browserVersion } from 'react-device-detect';
import PreLoginBanner from "./../component/PreLoginBanner";
import InputTypePassword from "./../component/InputTypePassword";
import PurpleHeading from "../component/PurpleHeading";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import { Link } from "react-router-dom";
import SelectDropDown from "../component/SelectDropDown";
import RegistrationUserInputField from "../component/RegistrationUserInputField";
import OTPBox from "../component/OTPBox";
import Form from "react-bootstrap/Form";
import RegistrationService from "../services/registration";
import Captcha from "../component/Captcha";
import AlertMsg from "../component/AlertMsg";
import OtherService from "../services/Other";
import Loader from "../component/Loader";
import { Eye, EyeOff } from "react-feather";
import toast from "react-hot-toast";
import ProfileService from "../services/Profile";
import { encrypt, isMobileNumberValid } from "../constants/commonFunction";
import ResendOtp from "../component/ResendOtp";
import { useDispatch } from "react-redux";
import { addTotalBrands, addCurrentBrand, addToken } from "../redux/slices/userTypeSlice";
import GridModal from "../component/Modals/GridModal";
import { addUserPersona } from "../redux/slices/currentUserSlice";
import { jwtDecode } from "jwt-decode";
// import useAuth from "../hooks/useAuth";
const Login = () => {
  const dispatch = useDispatch();

  // const { auth, setAuth } = useAuth();
  // const [twoButtonBlockShow, setTwoButtonBlockShow] = useState(false)
  ///ALL USE STATES//
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [brand, setBrand] = useState({id: "", title: ""})
  const [showPassword, setShowPassword] = useState(false);
  //Hierchies//
  const [persona, setPersona] = useState([]);
  const [language, setLanguage] = useState([]);
  const [brandType, setBrandType] = useState([]);
  //validation
  const [isLanguageValidation, setIsLanguageValidation] = useState("");
  const [isPersonaValidation, setIsPersonaValidation] = useState("");
  const [isMobileValidation, setIsMobileValidation] = useState("");
  const [isSapValidation, setIsSapValidation] = useState("");
  const [isCaptchaValidation, setIsCaptchaValidation] = useState("");
  const [isPasswordLoginValidation, setIsPassWordLoginValidation] = useState('')
  //OTP Match
  const [otpValue, setOtpValue] = useState("");
  //OTP BOX
  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [pin3, setPin3] = useState("");
  const [pin4, setPin4] = useState("");
  const [pin5, setPin5] = useState("");
  const [pin6, setPin6] = useState("");
  //Captcha
  const [isCaptchaText, setIsCaptchaText] = useState("");
  //  Select Dropdown
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedPersona, setSelectedPersona] = useState("");
  //OTP Submit For Forgot Password
  const [isOtp, setIsOtp] = useState("");
  // lOGIN FORM SUBMIT
  const [isOTPRequestBTN, setIsOTPRequestBTN] = useState(true)
  const [isLanguage, setIsLanguage] = useState("");
  const [isPersona, setIsPersona] = useState("");
  const [isSap, setIsSap] = useState("");
  const [isMobile, setIsMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showLoginBlock, setShowLoginBlock] = useState(true);
  const [loginMethod, setLoginMethod] = useState("OTP");
  //Forgot Password
  const [isForgotPasswordBlock, setIsForgotPasswordBlock] = useState(false);
  const [showPasswordBlock, setShowPasswordBlock] = useState(true);
  const [showLogFormBlock, setShowLogFormBlock] = useState(true);
  //Password  Match
  const [isResetPassword, setIsResetPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState("");
  const handleRegistrationPasswordInput = (e) => {
    setIsResetPassword(e.target.value);
  };
  // AlertBox MSG
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertPassword, setShowAlertPassword] = useState(false);
  const [showAlertOTP, setShowAlertOTP] = useState(false);
  //OTP Block
  const [otpMatchBox, isOTPMatchBox] = useState(false);
  //Forgot Password
  const [isForgotPasswordMobile, setIsForgotPasswordMobile] = useState("");
  const [isResetPasswordField, setIsResetPasswordField] = useState(false);
  const [showBrand, setShowBrand] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [passwordMismatch, setPasswordMismatch] = useState(false);

  //useNavigate
  const navigate = useNavigate();
  //ALL Functions

  const handleCaptchaChange = (e) => {
    setIsCaptchaText(e.target.value);
    setIsCaptchaValidation('')
  };

  const handleOTPMatch = (e) => {
    setIsOtp(e.target.value);
  };

  const otpValueFromField = Number(pin1 + pin2 + pin3 + pin4 + pin5 + pin6);
  // const handleOTPSubmit = () => {
  //   if (Number(otpValue) == otpValueFromField) {
  //     isOTPMatchBox(false);
  //     setIsResetPasswordField(true);

  //   }
  // };
  // const handleRegistrationConfirmPasswordInput = (e) => {
  //   setConfirmPassword(e.target.value);
  //   if(isResetPassword === e.target.value){
  //     setConfirmPasswordValidation('')
  //   }
  //   else{
  //     setConfirmPasswordValidation('Password do not match')
  //   }
  // };

  const handleRegistrationConfirmPasswordInput = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordValidation(''); 
  };
  

  const handleForgotPasswordBlock = () => {
    setIsForgotPasswordBlock(true);
    setShowLogFormBlock(false);
    setShowPasswordBlock(false);
    setPin1("");
    setPin2("");
    setPin3("");
    setPin4("");
    setPin5("");
    setPin6("");
    setIsResetPassword("")
    setConfirmPassword("")
    isOTPMatchBox(false);
    setIsForgotPasswordMobile("");
  };

  const isMobileNumberValid = (mobileNumber) => {
    const mobileNumberPattern = /^(\+\d{1,3}[- ]?)?[6-9]\d{9}$/;
    return mobileNumberPattern.test(mobileNumber);
  };

  const getErrorMessage = (payload, fallback) =>
    payload?.response?.message?.message || payload?.response?.message || payload?.message || fallback;

  // ALL USEEFFECTS
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      navigate("/landing")
    }
    
    OtherService.hierarchiesList().then((res) => {
      
      if (res.success) {
        let arr = [];
        let arr1 = [];
        res.response.hierarchiesDetails.forEach((item, key) => {

          const code = item.hierCode?.toLowerCase();  
          if (code === "engineer" || code === "bog") {
            return; 
          }
          
          if (!arr1.includes(item.description)) {
            arr1.push(item.description);
            arr.push({ 
              id: item.description,
              title: item.displayText,
              key,
              displayText: item.displayText
            });
          }
        });
        setPersona(arr);
        if(arr.length > 0)
          setSelectedPersona(arr[0])
        setLoading(false);
      }
    });
  }, []);
  //Language
  useEffect(() => {
    RegistrationService.getLanguages().then((res) => {
      if (res.success) {
        let arr2 = [];
        let arr3 = [];
        res.response.languageDetails.forEach((item, key) => {
          if (!arr3.includes(item.description)) {
            arr3.push(item.description);
            arr2.push({ id: item.description, title: item.description, key });
          }
        });
        setLanguage(arr2);
        if(arr2.length > 0)
          setSelectedLanguage(arr2[0]);
        setLoading(false); 
      }
    });
  }, []);
  //All FUNCTIONS
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleLanguageChange = (selectedValue) => {
    setSelectedLanguage(selectedValue);
    setIsLanguageValidation(" ");
  };
  const handlePersonaChange = (selectedValue) => {
    setSelectedPersona(selectedValue);
    setIsPersonaValidation(" ");
  };

  const handleSapChange = (e) => {
    setIsSap(e.target.value);
    setIsSapValidation('')
    const alphanumericOrNumericRegex = /^[a-zA-Z0-9]+$/;
        if (alphanumericOrNumericRegex.test(isSap)) {
          setIsSapValidation("");
        } else {
          setIsSapValidation("Invalid SAP Code");

        }
  };
  const handleMobileChange = (e) => {
    const mobileNumber = e.target.value;
    const mobileRegex = /^\d{10}$/;
    
    if (mobileRegex.test(mobileNumber)) {
      setIsMobileValidation('');
    } else {
      setIsMobileValidation('Invalid mobile no');
    }
    
    setIsMobile(mobileNumber);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleIsForgotPasswordMobile = (e) => {
    setIsForgotPasswordMobile(e.target.value);
  };
  const handleForgotPasswordOTPSubmit = () => {    
    const payload = {
      mobile_number: isForgotPasswordMobile,
    };  
    if(!isForgotPasswordMobile){
      toast.error("Mobile no is required");
      return;
    }  
    if(isForgotPasswordMobile && !isMobileNumberValid(isForgotPasswordMobile)) {
      toast.error("Entered mobile no is invalid.");
      return;
    }
    RegistrationService.verifyPhone(payload)
      .then((res) => {
        if (res.success) {
          if(res.response.status == "false") {
            toast.error(res.response.message);
            return;
          } else {
            setOtpValue(res.response.OTP);
            isOTPMatchBox(true);
            toast.success("6 digit otp has been send");
            // setIsLoginSuccess({ isLogin: true, text: res.response.message });
            // setTimeout(() => {
            // }, 3000);
          }
        } else {
          // setShowAlert(true);
          // setIsLoginSuccess({ isLogin: false, text: res.response.message });
          toast.error("Failed to send OTP");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.message || "Failed to send OTP");
      });
  };
  const handleLoginSubmit = async () => {

    if(brand.id && showLoginBlock) {      
      setShowLoginBlock(false)
      if(loginMethod === "OTP") {
        
        if (selectedPersona.id && (isSap || isMobile)) {
          const payload = {
                userType: selectedPersona.id.toLowerCase(),
                username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
                // password,
              };
          getBrand(payload);
          setShowLoginBlock(false)
          handleSendOTP();
        } else {
          toast.error("Please provide all the required details for login")
        }
      }
      return;
    }
    if(showLoginBlock) {      

      try {
        // if (!selectedLanguage) {
        //   toast.error("Select Language is required.");
        //   return;
          
        // }
        if (!selectedPersona) {
          toast.error("Select Persona is required.");
          return;
         
        }
        if (!isSap && (selectedPersona.id === "Dealer" || selectedPersona.id === "Retailer" || selectedPersona.id === "ARS")) {
          toast.error("SAP is required.");
          return;
          
        }
        if (!isMobile && (selectedPersona.id !== "Dealer" && selectedPersona.id !== "Retailer" && selectedPersona.id !== "ARS")) {
          toast.error("Mobile no is required.");
          return; 
        }

        if(isMobile && !isMobileNumberValid(isMobile)) {
          toast.error("Entered mobile no is invalid.");
          return;
        }
  
  
        if (selectedPersona.id && (isSap || isMobile)) {
          const payload = {
                userType: selectedPersona.id.toLowerCase(),
                username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
                // password,
              };
          getBrand(payload);
          // if (showLoginBlock === true) {
          //   setShowLoginBlock(!showLoginBlock);
          // } else {
          //   const payload = {
          //     userType: selectedPersona.id,
          //     username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
          //     // password,
          //   };
          //   getBrand(payload);
          //   if (loginMethod !== "OTP" && password) {
          //     handlePasswordLogin();
          //   } else {
          //     handleOtpLogin();
          //   }
          }
        
      } catch (error) {
        console.error("Error occurred:");
      }
    } 
    else {      

            // const payload = {
            //   userType: selectedPersona.id,
            //   username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
            //   password,
            // };
            if (loginMethod !== "OTP") {              
              handlePasswordLogin();
            } else {
              handleOtpLogin();
            }
    }
    
    
  };

  useEffect(() => {
    setBrand({id: "", title: ""});
    setShowBrand(false);
  }, [isMobile, isSap])

  async function getBrand(payload){
    setLoading(true);
    
    ProfileService.getLoginBrand(payload)
      .then(res => {
        setLoading(false);
        if (res.success) {
          const allBrand =
            res.response.length > 0
              ? res.response.map(item => {
                  return {
                    id: String(item.brand_id),
                    title: item.brand_name,
                    image: {uri: item.brand_logo_url + item.brand_logo},
                  };
                })
              : [];
          setBrandType(allBrand);
          dispatch(addTotalBrands({totalBrands: allBrand}))
          localStorage.setItem('allBrand', JSON.stringify(allBrand));
          if (allBrand.length > 1) {
            setShowBrand(true);
          } else if (allBrand.length == 1) {
            setShowLoginBlock(false)
            
            dispatch(addCurrentBrand({currentBrand: allBrand[0]}))
            setBrand(allBrand[0]);
            // sendOTPCb(allBrand[0])
            //  dispatch(
            //   addBrandName({
            //     brandName: allBrand[0].title,
            //   }),
            // );
            //  dispatch(
            //   addBrandUri({
            //     brandUri: allBrand[0].image.uri,
            //   }),
            // );
          } else {
            // setBrand({id:"",title:""});
            toast.show('Sorry! No brand found');
          }
        } else {
          // storeCurrentTime();
          toast.error(res.response.message);
        }
      })
      .catch(err => {
        toast("Cannot fetch brand(s)");
        setLoading(false);
      });
  };

  const handlePasswordLogin = async () => {    
    let isValidate = true;
    // if (!isCaptchaText) {
    //   toast.error("Captcha is required.");
    //   isValidate = false;
    // }
    // if(!password) {
    //   toast.error("Password is required.");
    //   return;
    // }
    // if (!password) {

    //   setIsPassWordLoginValidation("Password is required.");
    //   isValidate = false;
    // }    
    if (!password) {
      // setIsPassWordLoginValidation("Password is required.");
      toast.error("Password is required.");
      isValidate = false;
    }
    
    if (isValidate) {
      // if (captchaValue == isCaptchaText) {
        const payload = {
          userType: selectedPersona.id,
          username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
          // password: password,
          password: await encrypt(password),
          brand_id: brand.id,
          device_type: "browser",
          os_type: browserName,
          os_version: browserVersion,
          device_id: "1"
        };
        console.log("Password------>", payload.password);
        
        setIsButtonLoading(true);
        try {
          const res = await RegistrationService.login(payload);
          
          if (res.success) {
            storeLoginData(res.response);
            console.log("Login successful", res.response);
            navigateAfterLogin(res.response.isBasicProfileDone);
            // localStorage.removeItem('isSearchMobile');
            // localStorage.removeItem('isSearchName');
            // localStorage.removeItem('isSearchPurchaseDate');
          } else {
            const message = getErrorMessage(res, "Login failed. Please try again.");
            toast.error(message.message)
            handleLoginError(message);
          }
        } catch (error) {
          toast.error(getErrorMessage(error, "Login failed. Please try again."));
          // handleLoginError("Sorry, You cannot log into Rewards Connect. Please try again");
        } finally {
          setIsButtonLoading(false);
        }
      // } else {
      //   toast.error("Please enter valid captcha")
      // }
    }
  };

  const handleOtpLogin = async () => {
    let isValidate = true;
    // if (!isCaptchaText) {
    //   setIsCaptchaValidation("Captcha is required.");
    //   isValidate = false;
    // }
    if (isValidate) {
      // if (captchaValue == isCaptchaText) {
        try {
          if(pin1 && pin2 && pin3 && pin4 && pin5 && pin6){
            const payload = {
            otp: Number(`${pin1}${pin2}${pin3}${pin4}${pin5}${pin6}`),
            mobile: String(isMobile),
            userType: selectedPersona.id,
            usernameType:  isDealerOrRetailer(selectedPersona) ? 'sap_code' : 'mobile',
            sap_code: isSap,
            brand_id: brand.id,
            os_type: browserName,
            os_version: browserVersion,
            device_id: '1',
            device_type: 'browser',
          };
          console.log("PALOAD----------->", payload);
          setIsButtonLoading(true);
          const verifyOTPSubmit = await RegistrationService.validateOtp(payload);
          setIsButtonLoading(false);
          console.log("VALIDATE", JSON.stringify(verifyOTPSubmit))
          if (verifyOTPSubmit.success == true) {
            toast.success("Login successful")
            storeLoginData(verifyOTPSubmit.response);
            navigateAfterLogin(verifyOTPSubmit.response.isBasicProfileDone);
          } else {
            toast.error(getErrorMessage(verifyOTPSubmit, "Invalid OTP"))
            // console.log("ERROR!!!!");
            // handleLoginError(verifyOTPSubmit.response.message.message);
            }
          }
        } 
        catch (error) {
          setIsButtonLoading(false);
          toast.error("Invalid OTP")
          // handleLoginError("Sorry, You cannot log into Rewards Connect. Please try again");
        }
      // } else {
      //   handleCaptchaError();
      // }
    }
  };

  useEffect(() => {    
    if(isResetPassword && confirmPassword){
      handlePasswordUpdate();
    } else {
      handleOtpLogin();
    }
  }, [pin1, pin2, pin3, pin4, pin5, pin6]);

  const storeLoginData = (response) => {
    const accessToken = response.access_token;
    localStorage.setItem("userInfo", JSON.stringify(response))
    dispatch(addUserPersona({userPersona: response.description}));
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", response.refresh_token);
    // setAuth({accessToken, refreshToken: response.refresh_token})
    dispatch(addToken({token: {access: accessToken, refresh: response.refresh_token}}))
    const isBasicProfileDone = response.isBasicProfileDone == 'false' ? false : true;
    localStorage.setItem('isBasicProfileDone', JSON.stringify(isBasicProfileDone));
    if (response.userData) {
      const decodedToken = jwtDecode(accessToken);
      const aceessUserDetails = JSON.stringify({
        ...response.userData,
        description: decodedToken.description,
      });
      localStorage.setItem("userData", aceessUserDetails);
    }
  };

  const navigateAfterLogin = (isBasicProfileDone) => {
    // setShowAlert(true);
    // setIsLoginSuccess({
    //   isLogin: true,
    //   heading: "Success",
    //   text: "You have successfully logged in to Rewards Connect",
    // });
    setTimeout(() =>{
      if (isBasicProfileDone == 'false') {
        navigate("/basic-registration");
      } else {
        navigate("/landing");
      }
    }, 1000)
   

  };

  const handleLoginError = (message) => {
    setShowAlert(true);
    setIsLoginSuccess({
      isLogin: false,
      heading: "Login Error",
      text: message,
    });
    setTimeout(() => {
      navigate("/");
    }, 1000);
  };

  // const handleCaptchaError = () => {
  //   setShowAlert(true);
  //   setIsLoginSuccess({
  //     isLogin: false,
  //     heading: "Error",
  //     text: "Captcha does not match. Please try again",
  //   });
  //   setTimeout(() => {
  //     navigate("/");
  //   }, 5000);
  // };
 
  const isDealerOrRetailer = (persona) => {
    if (persona.id == "Dealer" || persona.id == "Retailer" || persona.id == "ARS") {
      return true;
    }

    return false;
  };

  const changeLoginMethodHandler = () => {
    // setShowAlert(false);
    // if(!showLoginBlock) {

    // }
    if(showLoginBlock) {
      if (loginMethod == "OTP") {
        setLoginMethod("Password")
        // setIsOTPRequestBTN(true)
      }
      else {
        // setIsOTPRequestBTN(false)
        setLoginMethod("OTP")
        
      }
    } else {
      if (loginMethod == "OTP") {
        setLoginMethod("Password")
        // setIsOTPRequestBTN(true)
      }
      else {
        // setIsOTPRequestBTN(false)
        setLoginMethod("OTP")
        sendOTP(brand.id);
      }
    }
    
  };
  // const handlePasswordUpdate = () => {

  //   if(!isResetPassword){
  //     toast.error("Please enter password");
  //     return;
  //   }
    
  //   if(!confirmPassword) {
  //     toast.error("Please confirm password");
  //     return;
  //   }

  //   if(!otpValueFromField) {
  //     toast.error("Please enter OTP");
  //     return;
  //   }
    
  //   if (isResetPassword != " " && isResetPassword === confirmPassword) {

  //    if(pin1 && pin2 && pin3 && pin4 && pin5 && pin6){ 
  //     const payload = {
  //       password: isResetPassword,
  //       otp: otpValueFromField,
  //     };

  //     RegistrationService.forgotPassword(payload)
  //       .then((res) => {
  //         if (res.success) {
  //           let password = isResetPassword;
  //           let passReg =
  //             /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
  //           if (passReg.test(password)) {
  //             toast.error(res.response.message)
  //             setIsLoginSuccess({ isLogin: true, text: res.response.message });
  //             setShowPasswordBlock(true);
  //               setShowLogFormBlock(true);
  //               setIsForgotPasswordBlock(false);
  //             // setTimeout(() => {
  //             //   setShowAlertPassword(false);
  //             //   setShowPasswordBlock(true);
  //             //   setShowLogFormBlock(true);
  //             //   setIsForgotPasswordBlock(false);
  //             // }, 3000);
  //           } else {
  //             toast.error(res.response.message)
  //           }
  //         } else {
  //           toast.error(res.response.message)
  //         }
  //       })
  //       .catch((error) => {
  //         toast.error("Something went wrong")
  //         console.error("Password Change Fail");
  //       });}
  //   }
  // };
  
  const handlePasswordUpdate = async () => {
  
    if (!isResetPassword) {
      toast.error("Please enter password");
      return;
    }
  
    if (!confirmPassword) {
      toast.error("Please confirm password");
      return;
    }

    if (isResetPassword !== confirmPassword) {
      // setConfirmPasswordValidation('Password do not match');
      toast.error("Passwords do not match");
      return;
    } 
  
    if (!otpValueFromField) {
      toast.error("Please enter OTP");
      return;
    }
  
    if (isResetPassword !== " " && isResetPassword === confirmPassword) {
      if (pin1 && pin2 && pin3 && pin4 && pin5 && pin6) {
        const payload = {
          password: isResetPassword,
          otp: otpValueFromField,
        };
  
        try {
          const res = await RegistrationService.forgotPassword(payload);

  
          if (res.success) {
            let password = isResetPassword;
            let passReg =
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
  
            if (passReg.test(password)) {
              toast.success(res.response.message);
              setIsLoginSuccess({ isLogin: true, text: res.response.message });
              setShowPasswordBlock(true);
              setShowLogFormBlock(true);
              setIsForgotPasswordBlock(false);
            } else {
              toast.error(res.response.message);
            }
          } else {
            toast.error(res.response.message);
          }
        } catch (error) {
          toast.error("Something went wrong");
          console.error("Password Change Fail");
        }
      }
    }
  };

  const handleLanguageFocus = () => {
    setIsLanguageValidation(" ");
  };
  const handleEditForm = (response) => {
    setPin1("")
    setPin2("")
    setPin3("")
    setPin4("")
    setPin5("")
    setPin6("")
    setIsCaptchaText("")
    setIsOTPRequestBTN(true)
    if (response == 'loginOTP') {
      // setTwoButtonBlockShow(false)
      setShowLoginBlock(true)
    }
    if (response == 'loginPassword') {

      // setTwoButtonBlockShow(false)
      setShowLoginBlock(true)
    }

  }

  async function sendOTP(brandId) {
    const payload = {
      mobile: String(isMobile),
      userType: selectedPersona.id,
      usernameType: isSap ? 'sap_code' : 'mobile',
      sap_code: isSap,
      brand_id: brandId
    }
    setIsButtonLoading(true)
    try {
      const sendOTPSubmit = await RegistrationService.sendOtp(payload)
      if (showLoginBlock === true) {
        setShowLoginBlock(false);
      }
      setIsButtonLoading(false)
      if (sendOTPSubmit.response.status == true) {
        setShowLoginBlock(false)
        setIsOTPRequestBTN(false)
        setShowAlertOTP(true)
        toast(sendOTPSubmit.response.message)

      }
      else {
        setShowAlertOTP(true)
        toast(sendOTPSubmit.response.message)
      }
    }
    catch (e) {
    }
  }

  async function handleSendOTP() {
    

    // if (!selectedLanguage) {
    //   toast.error("Select Language is required.");
    //   return;
      
    // }
    if (!selectedPersona) {
      toast.error("Select Persona is required.");
      return;
     
    }
    if (!isSap && (selectedPersona.id === "Dealer" || selectedPersona.id === "Retailer" || selectedPersona.id === "ARS")) {
      toast.error("SAP is required.");
      return;
      
    }
    if (!isMobile && (selectedPersona.id !== "Dealer" && selectedPersona.id !== "Retailer" && selectedPersona.id !== "ARS")) {
      toast.error("Mobile no is required.");
      return; 
    }

    if(isMobile && !isMobileNumberValid(isMobile)) {
      toast.error("Entered mobile no is invalid.");
      return;
    }

    const payloadBrand = {
      userType: selectedPersona.id.toLowerCase(),
      username: isDealerOrRetailer(selectedPersona) ? isSap : isMobile,
    };
    getBrand(payloadBrand);
    if(loginMethod !== "OTP") {
      
      setIsOTPRequestBTN(false);
      return;
    }

    // if (!isMobile || !isSap) {
    //   if (!isMobile) {
    //     setIsMobileValidation('Mobile No is required');
    //   }
    //   if (!isSap) {
    //     setIsSapValidation('SAP Code is required');
    //   }
    //   isValidate = false;
    // }
    // if (isValidate) {
    
    // }
  }
  const handleResentOtp = async () => {
    const payload = {
      mobile: String(isMobile),
      userType: selectedPersona.id,
    }
    try {
      const sendOTPSubmit = await RegistrationService.sendOtp(payload)
      setIsButtonLoading(false)
      if (sendOTPSubmit.response.status == true) {
        setPin1("")
        setPin2("")
        setPin3("")
        setPin4("")
        setPin5("")
        setPin6("") 
        setShowAlertOTP(true)
        setIsLoginSuccess({ isLogin: true, text: sendOTPSubmit.response.message })
        setTimeout(() => {
          setShowAlertOTP(false)
        }, 3000)

      }
      else {
        setShowAlertOTP(true)
        setIsLoginSuccess({ isLogin: false, text: sendOTPSubmit.response.message })
        setTimeout(() => {
          setShowAlertOTP(false)
        }, 3000)
      }
    }
    catch (e) {
    }
  }

  useEffect(() => {
    if(brand.id) {
      dispatch(addCurrentBrand({currentBrand: brand}))
      if(loginMethod === "OTP") {
        sendOTP(brand.id);
      } else {
        setShowLoginBlock(false);
      }
      localStorage.setItem('currentBrand', JSON.stringify(brand));
    }
  }, [brand])

  function brandModalHandler() {
    setShowBrand(p => !p);
  }

  function canAttemptLogin() {
    const data = JSON.parse(localStorage.getItem("loginAttempts")) || {
      count: 0,
      lockUntil: null,
    };
    if (data.lockUntil && Date.now() < data.lockUntil) {
      const remaining = Math.ceil((data.lockUntil - Date.now()) / 1000 / 60);
      toast.error(`Too many failed attempts. Try again after ${remaining} min(s).`);
      return false;
    }
    return true;
  }
  
  function recordFailedAttempt() {
    const data = JSON.parse(localStorage.getItem("loginAttempts")) || {
      count: 0,
      lockUntil: null,
    };
    data.count += 1;
    if (data.count > 3) {
      data.lockUntil = Date.now() + 20 * 60 * 1000;
      data.count = 0; 
    }
    localStorage.setItem("loginAttempts", JSON.stringify(data));
  }
  
  function resetAttempts() {
    localStorage.removeItem("loginAttempts");
  }

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="loginBg">
        <div className="p-0 registrationImgBlock stickyBlock">
          <PreLoginBanner />
        </div>
        <div className="p-0 registrationFromBlock">
          <div className="loginFromsBlock">
            {showLogFormBlock && (
              <div className="rightLoginForm">
                {showLoginBlock ? (
                  <div className="frm-login ad-login">
                    <div className="formBlock pb-0">
                      <PurpleHeading purpleHeadingText="Login to unlock unlimited rewards" />
                      {/* <div className="slangBox">
                        <SelectDropDown
                          labelName="Select display language"
                          page='searchFilter'
                          requiredStar="*"
                          options={language}
                          onChange={handleLanguageChange}
                          selectedValue={selectedLanguage}
                          setSelectedValue={setSelectedLanguage}
                          onFocus={handleLanguageFocus}
                        />
                        
                      </div> */}
                      <div className="selectBoxWrap">
                        <SelectDropDown
                          labelName="Select your persona"
                          requiredStar="*"
                          page='searchFilter'
                          options={persona}
                          onChange={handlePersonaChange}
                          selectedValue={selectedPersona}
                          setSelectedValue={setSelectedPersona}
                        />
                        
                      </div>
                      {isDealerOrRetailer(selectedPersona) && (
                        <div>
                          <InputField
                            inputFieldLabel="SAP code"
                            requiredStar="*"
                            value={isSap}
                            onChange={handleSapChange}
                          />

                          {/* {isSapValidation && (
                            <div className="error-message">
                              {isSapValidation}
                            </div>
                          )} */}
                          {/* {isMobileValidation && (
                            <div className="error-message">
                              {isMobileValidation}
                            </div>
                          )} */}
                        </div>
                      )}
                      {!isDealerOrRetailer(selectedPersona) && (
                        <div>
                          <InputField
                            inputFieldLabel="Mobile no"
                            requiredStar="*"
                            value={isMobile}
                            onChange={(e) => {
                              if(e.target.value.length <= 10){
                                handleMobileChange(e);
                              }
                            }}
                            maxLength={10}
                          />
                        </div>
                      )}
                      {/* {showBrand && (
                        <div className="mt-3">
                          <SelectDropDown
                          labelName="Select Brand"
                          requiredStar="*"
                          page='searchFilter'
                          options={brandType}
                          // onChange={setBrand}
                          selectedValue={brand}
                          setSelectedValue={setBrand}
                        />
                        </div>
                      )} */}

                      <div></div>
                    </div>
                  </div>
                ) : (
                  <div className="frm-p-block">
                    {loginMethod == "OTP" && (
                      <div className="formBlock">
                        <PurpleHeading purpleHeadingText="Login to unlock unlimited rewards" />
                        <div className="linkColor mt-2 edit-text-right" onClick={() => { handleEditForm('loginOTP') }}><u>Edit the form</u></div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel="Selected language"
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel="English"
                          />
                        </div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel="Your persona"
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={selectedPersona.title}
                          />
                        </div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel={
                              isDealerOrRetailer(selectedPersona.id)
                                ? "SAP Code"
                                : "Mobile no"
                            }
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={
                              isDealerOrRetailer(selectedPersona.id)
                                ? isSap
                                : isMobile
                            }
                          />
                        </div>
                        {/* <PrimaryGradientButton buttonText="Request OTP" onClick={handleSendOTP} /> */}

                        <OTPBox
                          pin1={pin1}
                          pin2={pin2}
                          pin3={pin3}
                          pin4={pin4}
                          pin5={pin5}
                          pin6={pin6}
                          setPin1={setPin1}
                          setPin2={setPin2}
                          setPin3={setPin3}
                          setPin4={setPin4}
                          setPin5={setPin5}
                          setPin6={setPin6}
                        />
                        <div className="linkColor edit-text-right" ><u><ResendOtp onClick={handleResentOtp}  resendText={"Resent OTP"}/></u></div>
                        
                        {/* <Captcha
                          captchaValue={captchaValue}
                          onClick={handleRefreshCaptcha}
                        />
                        <InputField
                          inputFieldLabel="Captcha"
                          requiredStar="*"
                          value={isCaptchaText}
                          onChange={handleCaptchaChange}
                        />
                        {isCaptchaValidation && (
                          <div className="error-message">
                            {isCaptchaValidation}
                          </div>
                        )} */}
                      </div>
                    )}

                    {loginMethod != "OTP" && showPasswordBlock && (
                      <div className="formBlock pb-0">
                        <PurpleHeading purpleHeadingText="Login to unlock unlimited rewards" />
                        <div className="linkColor mt-2 edit-text-right" onClick={() => { handleEditForm('loginPassword') }}><u>Edit the form</u></div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel="Selected language"
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={selectedLanguage.title}
                          />
                        </div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel="Your persona"
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={selectedPersona.title}
                          />
                        </div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel={
                              (selectedPersona.id =='Dealer' || selectedPersona.id =='Retailer' || selectedPersona.id =='ARS')
                                ? "SAP Code"
                                : "Mobile no"
                            }
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={
                              (selectedPersona.id =='Dealer' || selectedPersona.id =='Retailer' || selectedPersona.id =='ARS')
                                ? isSap
                                : isMobile
                            }
                          />
                        </div>
                        <div className="registrationTopText">
                          <RegistrationUserInputField
                            className="registrationTextLabel form-label"
                            formLabel={"Brand"}
                            requiredStar="*"
                          />
                          <RegistrationUserInputField
                            className="registrationTextData form-label"
                            formLabel={brand.title}
                          />
                        </div>
                        <div className="pswBlock">
                          <Form.Label>
                            Password <span className="redStar">*</span>
                          </Form.Label>
                          <div className="position-relative">
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              value={password}
                              onChange={handlePasswordChange}
                            />
                            <span
                              onClick={togglePasswordVisibility}
                              className="passwordShowHide"
                            >
                              {showPassword ? <Eye /> : <EyeOff />}
                            </span>
                          </div>
                        </div>

                        {isPasswordLoginValidation && (
                          <div className="error-message">
                            {isPasswordLoginValidation}
                          </div>
                        )}
                        {/* <div className="resendText">
                          <div
                            className="linkColor mt-2"
                            onClick={handleForgotPasswordBlock}
                          >
                            <u>Forgot Password?</u>
                          </div>
                        </div> */}
                        {/* <Captcha
                          captchaValue={captchaValue}
                          onClick={handleRefreshCaptcha}
                        />
                        <InputField
                          inputFieldLabel="Captcha"
                          requiredStar="*"
                          value={isCaptchaText}
                          onChange={handleCaptchaChange}
                        />
                        {isCaptchaValidation && (
                          <div className="error-message">
                            {isCaptchaValidation}
                          </div>
                        )} */}
                      </div>
                    )}
                  </div>
                )}

                <div className="formBlock pt-0">

                  {!isOTPRequestBTN &&
                    (
                      <div className="mt-4">

                        <PrimaryGradientButton
                          buttonText={isButtonLoading ? "Processing..." : loginMethod === "OTP"
                            ? "Verify OTP"
                            : "Sign In"}
                          onClick={handleLoginSubmit}
                          disabled={isButtonLoading}
                        // className={twoButtonBlockShow == true ? 'mt-0' : 'mt-5'}
                        />
                      </div>

                    )
                  }
                  {isOTPRequestBTN && (
                    <div className="mt-4">
                      <PrimaryGradientButton onClick={handleSendOTP}
                        buttonText={
                          isButtonLoading
                            ? "Processing..."
                            : loginMethod === "OTP"
                              ? "Request OTP"
                              : "Next"
                        }
                        disabled={isButtonLoading} 
                        />
                    </div>
                  )}

                       <div className="resendText">
                          <div
                            className="mt-2"
                          >
                            <u className="linkColor" onClick={handleForgotPasswordBlock}>Forgot Password?</u>
                          </div>
                        </div>

                  <>
                    <p className="orText mt-20">Or</p>
                    <div className="mt-4">

                    <PrimaryOutLineButton
                      onClick={changeLoginMethodHandler}
                      outlinebuttonText={
                        loginMethod == "OTP"
                          ? "Sign In Via Password"
                          : "Sign In Via OTP"
                      }
                      className="mt-20"
                    />
                    </div>
                  </>

                  <p className="mt-20 text-center">
                    Don’t have an account?{" "}
                    <Link to="/registration" className="linkColor">
                      {/* {" "}
                      Sign up{" "} */}
                      Sign Up
                    </Link>
                  </p>
                  {/* <div className="my-2">
                    {showAlertOTP && (
                      <AlertMsg
                        alertBoxColor={
                          isLoginSuccess.isLogin ? "successAlert" : "FailedAlert"
                        }
                        heading={isLoginSuccess.heading}
                        text={isLoginSuccess.text}
                      />
                    )}

                  </div> */}
                </div>

                {/* <div className="alertBoxWrap">
                  {showAlert && (
                    <AlertMsg
                      alertBoxColor={
                        isLoginSuccess.isLogin ? "successAlert" : "FailedAlert"
                      }
                      heading={isLoginSuccess.heading}
                      text={isLoginSuccess.text}
                    />
                  )}
                </div> */}
              </div>
            )}

            {/*Forgot Password*/}
            {isForgotPasswordBlock && (
              <div className="rightLoginForm">
                <div className="frm-login ">
                  <div className="formBlock">
                    <PurpleHeading purpleHeadingText="Forgot Password?" />
                    <div className="registrationTopText">
                      <div className="leftFullWidthInput">
                        <InputField
                          inputFieldLabel="Mobile No"
                          requiredStar="*"
                          autocomplete="off"
                          // value={isMobile}
                          value = {isForgotPasswordMobile}
                          name="mobile"
                          onChange={(e) => {
                            if(e.target.value.length <= 10){
                              handleIsForgotPasswordMobile(e);
                            }
                          }}
                          maxLength={10}
                        />
                      </div>
                      <div
                        className="linkColor"
                        onClick={handleForgotPasswordOTPSubmit}
                      >
                        <u>Send OTP</u>
                      </div>
                    </div>

                    {showAlert && (
                      <div className="alertBoxWrap mt-3 w-100">
                        <AlertMsg
                          alertBoxColor={
                            isLoginSuccess.isLogin
                              ? "successAlert"
                              : "FailedAlert"
                          }
                          heading={isLoginSuccess.heading}
                          text={isLoginSuccess.text}
                        />
                      </div>
                    )}

                    {otpMatchBox && (
                      <>
                        {/* <div className="registrationTopText">
                          <div className="otpBox mt-3">
                            <OTPBox
                              pin1={pin1}
                              pin2={pin2}
                              pin3={pin3}
                              pin4={pin4}
                              pin5={pin5}
                              pin6={pin6}
                              setPin1={setPin1}
                              setPin2={setPin2}
                              setPin3={setPin3}
                              setPin4={setPin4}
                              setPin5={setPin5}
                              setPin6={setPin6}
                            />
                          </div>

                        </div> */}
                        {/* <div className="resendText">
                          <PrimaryGradientButton buttonText="Verify OTP" onClick={handleOTPSubmit} />
                        </div> */}
                        <div>
                          <br />
                          <InputTypePassword
                            inputFieldLabel="Password"
                            requiredStar="*"
                            autocomplete="off"
                            value={isResetPassword}
                            onChange={handleRegistrationPasswordInput}
                            name="password"
                          />
                          <br />
                          <InputTypePassword
                            inputFieldLabel="Confirm Password"
                            requiredStar="*"
                            autocomplete="off"
                            value={confirmPassword}
                            onChange={handleRegistrationConfirmPasswordInput}
                            name="confirmPassword"
                          />
                          {isSubmitted && confirmPasswordValidation && (
                            <p style={{ color: 'red' }}>{confirmPasswordValidation}</p>
                          )}

                          <div className="registrationTopText">
                          <div className="otpBox mt-3">
                            <OTPBox
                              pin1={pin1}
                              pin2={pin2}
                              pin3={pin3}
                              pin4={pin4}
                              pin5={pin5}
                              pin6={pin6}
                              setPin1={setPin1}
                              setPin2={setPin2}
                              setPin3={setPin3}
                              setPin4={setPin4}
                              setPin5={setPin5}
                              setPin6={setPin6}
                            />
                          </div>
                          </div>
                          {confirmPasswordValidation && 
                          < div className="error-message">{confirmPasswordValidation}
                          </div>
                          }
                          <PrimaryGradientButton
                            className="my-4"
                            buttonText="Submit"
                            requiredStar="*"
                            onClick={handlePasswordUpdate}
                          />

                          {/* {showAlertPassword && (
                            <AlertMsg
                              alertBoxColor={
                                isLoginSuccess.isLogin
                                  ? "successAlert"
                                  : "FailedAlert"
                              }
                              heading={isLoginSuccess.heading}
                              text={isLoginSuccess.text}
                            />
                          )} */}
                        </div>
                      </>
                    )}

                    {/* {isResetPasswordField && (
                      <div>
                        <InputTypePassword
                          inputFieldLabel="Password"
                          requiredStar="*"
                          autocomplete="off"
                          value={isResetPassword}
                          onChange={handleRegistrationPasswordInput}
                          name="password"
                        />

                        <InputTypePassword
                          inputFieldLabel="Confirm Password"
                          requiredStar="*"
                          autocomplete="off"
                          value={confirmPassword}
                          onChange={handleRegistrationConfirmPasswordInput}
                          name="confirmPassword"
                        />

                        <PrimaryGradientButton
                          className="mb-3"
                          buttonText="Submit"
                          requiredStar="*"
                          onClick={handlePasswordUpdate}
                        />

                        {showAlertPassword && (
                          <AlertMsg
                            alertBoxColor={
                              isLoginSuccess.isLogin
                                ? "successAlert"
                                : "FailedAlert"
                            }
                            heading={isLoginSuccess.heading}
                            text={isLoginSuccess.text}
                          />
                        )}
                      </div>
                    )} */}

                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <GridModal title={"Choose brand"} show={showBrand} onHide={brandModalHandler} data={brandType} setSelected={setBrand} selected={brand} />
      </div>
    </>
  );
};

export default Login;
